import nadlanDealsComponent from './nadlan-deals.component';

const nadlanDealsModule = angular.module('nadlanDeals', [
])
  .component('nadlanDeals', nadlanDealsComponent)
  .name;

export default nadlanDealsModule;
